<div class="welcome-image">
  <div class="welcome-headline" i18n="portal-welcome-headline">
    <div class="title">shooting.global</div>
    <div>For shooters. For clubs.</div>
    <div class="hint"> Scroll down </div>
  </div>
</div>
<div class="welcome-summary">
  <ul style="list-style-type: &quot;➤ &quot;">
    <li>Manage competitions & registrations</li>
    <li>Enter & publish results (replaces paper)</li>
    <li>Track individual progress</li>
  </ul>
  <p>No more paper, nor e-mail, nor spreadsheets!</p>
</div>
<h1>Welcome</h1>
<p>
  shooting.global is a web application designed by shooter for shooters. It helps with managing championships, by
  providing registration, results entry, results publishing - useful for small clubs.
</p>
<p> For individual shooters provides progress monitoring and chart. </p>
<p> Designed to be used from laptops and mobile devices on shooting lanes. </p>
<h1>Demos</h1>
<div class="demos-list">
  <a href="https://youtu.be/SP2PWQRmGrg" target="_blank" rel="noopener" class="play-link">
    <div class="play-link-preview">
      <mat-icon class="icon_64px">play_circle_outline</mat-icon>
    </div>
    <div> PL: Tworzenie klubu </div>
  </a>

  <a href="https://youtu.be/hoJL12mfG5Y" target="_blank" rel="noopener" class="play-link">
    <div class="play-link-preview">
      <mat-icon class="icon_64px">play_circle_outline</mat-icon>
    </div>
    <div> EN: Club creation </div>
  </a>
</div>
